import { render, staticRenderFns } from "./CustomerTabsDetails.vue?vue&type=template&id=9e0dd682"
import script from "./CustomerTabsDetails.vue?vue&type=script&lang=js"
export * from "./CustomerTabsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports